"use client";

import z from "zod";

import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunitiesGivingCampaigns } from "./keyCommunitiesGivingCampaigns";
import { givingCampaignWithCommunitySchema } from "./schema/givingCampaignWithCommunitySchema";

export type UseRequestCommunitiesGivingCampaignsProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestCommunitiesGivingCampaigns = ({
  id,
  ...props
}: UseRequestCommunitiesGivingCampaignsProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: z.object({
        results: z.array(givingCampaignWithCommunitySchema),
        total: z.number(),
      }),
      urlBackendPath: `/communities/${id}/giving-campaigns`,
    },
    queryKey: keyCommunitiesGivingCampaigns({ id }),
  }),
});
